import * as kontentAIComponentMapping from '../kontent_ai_mapping';
import { DataMapper, SupportedDataSources } from '../types';

export class GlobalDataMapping {
  private dataMapping: DataMapper;
  public getDataMapping: () => DataMapper;
  private static instance: GlobalDataMapping;

  private constructor() {
    this.dataMapping = {
      [SupportedDataSources.KontentAi]: kontentAIComponentMapping,
    };
    this.getDataMapping = () => this.dataMapping;
  }

  public static getInstance(): GlobalDataMapping {
    if (!this.instance) {
      this.instance = new GlobalDataMapping();
    }

    return this.instance;
  }
}

export const getGlobalDataMapping = (): DataMapper => {
  return GlobalDataMapping.getInstance().getDataMapping();
};
